export default __webpack_public_path__ + "static/07-290ecbca68898ba1160b82538af33833.png";